import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableContainer = styled.div`
  width: 100%;
  height: 300px;
  overflow-y: scroll;
`;

export const Thead = styled.thead`
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: ${ColorSF2.white};
`;

export const TrHead = styled.tr`
  background-color: ${ColorSF2.white};
  display: flex;
  justify-content: end;
  height: 32px;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;

export const Tbody = styled.tbody`
  background-color: ${ColorSF2.white};
  width: 100%;
`;

export const Th = styled.th`
  text-align: left;
  font-size: 12px;
  flex: 1;
  white-space: nowrap;
  display: flex;
  align-items: center;
  padding: 5px;
  padding-left: 15px;
`;

export const TrBody = styled.tr`
  width: 100%;
  min-height: 32px;
  display: flex;
`;

export const Td = styled.td`
  border-bottom: 1px solid ${ColorSF2.mediumGray};
  padding: 5px;
  padding-left: 15px;
  font-size: 14px;
  flex: 1;
  display: flex;
  align-items: center;
  white-space: normal;
  font-weight: normal;
`;

export const IconWrapper = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 5px;
`;

export const SortColumn = styled.div`
  cursor: pointer;
  display: flex;
  columns: row;
  justify-content: ${props => (props.center ? 'center' : 'left')};
  align-items: center;
  margin-left: ${props => (props.marginLeft ? '10px' : '0px')};
  font-weight: normal;
`;

export const CheckboxTh = styled.th`
  width: 30px;
  padding-left: 10px;
  text-align: center;
  display: flex;
  align-items: center;
`;

export const CheckboxTd = styled.td`
  width: 30px;
  text-align: center;
  padding-left: 10px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
